import React from "react";
import notification1 from "../../../assets/images/notification1.svg";
import notification2 from "../../../assets/images/notification2.svg";

export const Activity = () => {
  return (
    <div className="h-[82.5vh] flex flex-col justify-center items-center    bg-cover w-[100vw]">
      <div className="absolute top-[25%] ">
        <img
          src={notification1}
          alt="no-search"
          className="w-[15rem]  border-[1px] border-white "
        />
        <img
          src={notification2}
          alt="no-search-text"
          className="w-[15rem] mt-10 "
        />
      </div>
    </div>
  );
};
